import { StyledTooltip } from './styles';

const Tooltip = props => <StyledTooltip {...props} />;

export default Tooltip;
